import * as XLSX from 'xlsx';

function extractCellText(cell: HTMLTableCellElement): string {
  let out = '';

  const walk = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      out += node.textContent ?? '';
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    const el = node as HTMLElement;
    const refIndex = el.getAttribute('data-kim-ref');
    if (refIndex !== null) {
      out += `[${refIndex}]`;
      return;
    }
    el.childNodes.forEach(walk);
  };

  cell.childNodes.forEach(walk);
  return out.replace(/\s+/g, ' ').trim();
}

function extractRows(table: HTMLTableElement): string[][] {
  const rows: string[][] = [];

  const pushRow = (htmlRow: HTMLTableRowElement) => {
    const cells = Array.from(htmlRow.cells).map(extractCellText);
    rows.push(cells);
  };

  if (table.tHead) {
    Array.from(table.tHead.rows).forEach(pushRow);
  }
  Array.from(table.tBodies).forEach((body) => {
    Array.from(body.rows).forEach(pushRow);
  });

  return rows;
}

export function exportKimTableToXlsx(table: HTMLTableElement, filename = 'kim-table.xlsx'): void {
  const rows = extractRows(table);
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Table');
  XLSX.writeFile(workbook, filename);
}
